













import { Component, Prop, Vue } from 'vue-property-decorator';
import { BreadcrumbItem, NavigationItem } from '@/types/contentServerContract';
import appStore from '@/core/app/app.store';

@Component
export default class SideNavigation extends Vue {
    @Prop({ required: true, type: Array })
    private navigationItems!: NavigationItem[];

    private get breadCrumbItems() {
        const breadCrumbItems = appStore.breadcrumb ?? null;
        return breadCrumbItems.length > 0 ? breadCrumbItems : null;
    }

    private get activeCategory(): BreadcrumbItem | null {
        if (!this.breadCrumbItems) return null;
        const index = this.breadCrumbItems.length >= 2 ? 2 : 1;
        return this.breadCrumbItems[this.breadCrumbItems.length - index];
    };

    private get activeMenu() {
        if (!this.breadCrumbItems) return null;
        return this.breadCrumbItems[this.breadCrumbItems.length - 1];
    }
}
